const ACTION_ENUM = {
  READ_VULNERABILITY: 'PUBLIC_READ_VULNERABILITY',
  MANAGE_VULNERABILITY: 'MANAGE_VULNERABILITY',

  READ_MERGE_REQUEST: 'PUBLIC_READ_MERGE_REQUEST',
  CREATE_MERGE_REQUEST: 'CREATE_MERGE_REQUEST',
  EDIT_STATUS_OF_MERGE_REQUEST: 'EDIT_STATUS_OF_MERGE_REQUEST',
  GENERAL_EDIT_MERGE_REQUEST: 'GENERAL_EDIT_MERGE_REQUEST',
  DO_MERGE_MERGE_REQUEST: 'DO_MERGE_MERGE_REQUEST',
  TOGGLE_AUTO_MERGE: 'TOGGLE_AUTO_MERGE',
  APPROVE_MERGE_REQUEST: 'APPROVE_MERGE_REQUEST',

  READ_DISCUSSION: 'PUBLIC_READ_DISCUSSION',
  CREATE_DISCUSSION: 'PUBLIC_CREATE_DISCUSSION',
  RESOLVE_DISCUSSION: 'RESOLVE_DISCUSSION',
  EDIT_DISCUSSION: 'EDIT_DISCUSSION',
  DELETE_DISCUSSION: 'DELETE_DISCUSSION',

  READ_CI_CD: 'PUBLIC_READ_CI_CD',
  EXECUTE_CI_CD: 'EXECUTE_CI_CD',
  DELETE_PIPELINE: 'DELETE_PIPELINE',
  MANAGE_CI_CD_RESOURCES: 'MANAGE_CI_CD_RESOURCES',
  RESET_RUNNER_CACHE: 'RESET_RUNNER_CACHE',
  MANAGE_PIPELINE_SCHEDULE: 'MANAGE_PIPELINE_SCHEDULE',
  MANAGE_CI_CD_SETTINGS: 'MANAGE_CI_CD_SETTINGS',

  READ_ISSUE: 'PUBLIC_READ_ISSUE',
  CREATE_ISSUE: 'PUBLIC_CREATE_ISSUE',
  GENERAL_EDIT_ISSUE: 'GENERAL_EDIT_ISSUE',
  EDIT_ISSUE_STATUS: 'EDIT_ISSUE_STATUS',
  DELETE_ISSUE: 'DELETE_ISSUE',
  READ_ISSUE_NOTE: 'PUBLIC_READ_ISSUE_NOTE',
  CREATE_ISSUE_NOTE: 'PUBLIC_CREATE_ISSUE_NOTE',
  EDIT_ISSUE_NOTE: 'EDIT_ISSUE_NOTE',
  DELETE_ISSUE_NOTE: 'DELETE_ISSUE_NOTE',

  MANAGE_TAG_API: 'MANAGE_TAG_API',
  PUSH: 'PUSH',

  MANAGE_SCRIPTS: 'MANAGE_SCRIPTS',
  MANAGE_SCRIPT_VARIABLES: 'MANAGE_SCRIPT_VARIABLES',

  MANAGE_ENVIRONMENTS: 'MANAGE_ENVIRONMENTS',
  MANAGE_DEPLOYMENTS: 'MANAGE_DEPLOYMENTS'
};
export default ACTION_ENUM;
